import { putChangePassword } from "helpers/backend_helper";
import { userChangePasswordSuccess, userChangePasswordError } from "./reducer";
import { Constant } from "utils/enums";
import { toast } from "react-toastify";
import { Environment } from "environment";
import { NavigateFunction } from "react-router-dom";

export const userChangePassword =
  (passwordData: any, navigate: NavigateFunction) =>
  async (dispatch: any) => {
    try {
      if (Environment.apiUrl) {
        
        const token = JSON.parse(localStorage.getItem(Constant.access_token) || "");

        if (!token) {
          throw new Error("No token found. Please log in again.");
        }

        const response: any = await putChangePassword({
          oldPassword: passwordData.oldPassword,
          newPassword: passwordData.newPassword,
        });

        if (response?.access_token && response?.refresh_token) {
          localStorage.setItem(Constant.access_token, JSON.stringify(response.access_token));
          localStorage.setItem(Constant.refresh_token, JSON.stringify(response.refresh_token));
        }

        dispatch(userChangePasswordSuccess("Your password has been changed successfully."));
        if (response?.success) {
          toast.success("Your password has been updated.");
          setTimeout(() => {
           navigate("/manage-products");
  }, 1000);
        }
      }
    } catch (error: any) {
      toast.error("Failed to change the password.");
      dispatch(userChangePasswordError(error.message || "Failed to change password."));
    }
  };
